import { render, staticRenderFns } from "./GameSearchDialog.vue?vue&type=template&id=2d9d1451&scoped=true"
import script from "./GameSearchDialog.vue?vue&type=script&lang=js"
export * from "./GameSearchDialog.vue?vue&type=script&lang=js"
import style0 from "./GameSearchDialog.vue?vue&type=style&index=0&id=2d9d1451&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d1451",
  null
  
)

export default component.exports